export default __webpack_public_path__ + "static/react-logo-9e99c0d27d88e6d406852173fccafdb0.png";